import { ButtonProps } from "shared/ui/button";

import { ConnectButton as AppKitConnectWalletButton } from "./app-kit-button";
import { ConnectButton as WagmiConnectButton } from "./wagmi-button";

export const Button = (props: ButtonProps) => {
  return import.meta.env.VITE_WALLET === "wagmi" ? (
    <WagmiConnectButton {...props} />
  ) : (
    <AppKitConnectWalletButton {...props} />
  );
};
